import React from "react";

import Header from "./Header";
import HeaderLight from "../layout/HeaderLight";
import { Role } from "../../models/enums";
import { sessionGet, sessionProfileGet } from "../../services/authService";
import pkg from "../../../package.json";

const Layout = ({ children, isVideoCallActive = false }) => {
  const logged = sessionGet();
  const profileInfo = sessionProfileGet();
  const activeRole = profileInfo?.userData?.active_role;
  const isProfessional = activeRole === Role.PROFESSIONAL;
  const hideHeader = isVideoCallActive && !isProfessional;

  return (
    <div
      className={`layout${isProfessional ? " layout--professional" : ""}${
        hideHeader ? " layout--video-call" : ""
      }`}
    >
      {!hideHeader && (logged ? <Header /> : <HeaderLight />)}
      <main className="main">{children}</main>
      {pkg?.version && (
        <div className="version">{"Versión: " + pkg?.version}</div>
      )}
    </div>
  );
};

export default Layout;
